
import axios from 'axios';
const BACKEND_URL = 'https://langserve-copilot-dp7nm56cca-as.a.run.app'

export const getBooks = async () => {
    try {
        const response = await axios.get(`${BACKEND_URL}/v4/cpg/local_search_books`, {
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}  